export const copyTextToClipboard = (text: string) => {
  if (navigator?.clipboard !== undefined) {
    return navigator.clipboard.writeText(text);
  }

  throw new Error("The Clipboard API is not available");
};
